module.exports = __webpack_public_path__ + "img/extended.b2b094c8.png";